import _ from 'lodash';

const LayerControls = (name) => require('../../controls').get(name);
import { RetentionSpreadsheet } from '../../../spreadsheets/retention-spreadsheet';
import { loading, unloading } from '../../../scripts/shared';

import layers from '../../layers';
import translate from '../tools/translate';
import Dialog from './Dialog';
import environment from '../../environment';

class Retention extends Dialog {
    constructor (area) {
        const contexts: {label: string, context: string}[] = [
            {label: translate('Common.RetentionLayer'), context: 'Retention', mainLayer: true},
        ];
        super(translate('Common.SelectedCustomers'), area, contexts);
        this.rangePicking = false;
        this.saveAsExcel = this.saveAsExcel.bind(this);
    }

    populateLayers (refresh? = false) {
        this._features = [];

        const filterPeriod = (this: any).filterPeriod;
        if(refresh){
            LayerControls('Retention').refreshControl(filterPeriod);
        }

        return new Promise((resolve) => {
            const retentionLayer = layers.get('Retention');
            if (retentionLayer.visible()) {
                this.addToLayers(retentionLayer);
            }
            resolve();
        });
    }

    saveAsExcel (e) {
        e.preventDefault();
        loading();
        setTimeout(() => {
            (new RetentionSpreadsheet(true)).mount(this.featuresProperties).create().saveAsExcel();
            unloading();
        }, 300);
    }

    updateDataSources () {
        let tableConfig;
        let chartConfig;

        this.seriesColors = [
            '#2ecc71',
            '#1ABC9C',
            '#3498DB',
            '#9B59B6',
            '#E74C3C',
            '#f39c12',
            '#F1C40F',
            '#95a5a6'
        ];

        if ((this: any)._type.value() === 'name') {
            tableConfig = this.getTableConfig(new kendo.data.DataSource({
                data: this.featuresProperties
            }), [
                {
                    field: 'name',
                    title: 'Nome',
                    locked: true,
                    template: `<span title="#: name #" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 170px;">#: name #</span>`,
                    lockable: false,
                    width: 170
                },
                { field: 'gender', title: 'Sexo', width: 40 },
                { field: 'mobileNumber', title: 'Celular', width: 170 },
                { field: 'phoneNumber', title: 'Telefone', width: 170 },
                { field: 'email', title: 'Email', width: 200 },
                { field: 'family', title: 'Veículo', width: 100 },
                { field: 'chassi', title: 'Chassi', width: 165 }
            ]);
            chartConfig = this.getChartConfig(this.createDataSource(0, 0, 'gender'));
        } else if ((this: any)._type.value() === 'type') {
            const types = [
                { color: '#3498DB', title: 'OwnRetention' },
                { color: '#9B59B6', title: 'GroupSpreading' },
                { color: '#f39c12', title: 'BrandSpreading' },
                { color: '#E74C3C', title: 'NoRetention' },
                { color: '#9B59B6', title: 'GroupRetention' },
                { color: '#1ABC9C', title: 'BrandRetention' },
            ].map(({color, title}) => ({color, text: translate(`Retention.Classification.${title}`)}));

            const tableDataSource = this.createDataSource();
            const chartDataSource = this.createDataSource(7, 16);

            chartDataSource.read();
            this.seriesColors = chartDataSource.view().map(d => _.find(types, t => _.truncate(t.text, {
                length: 16,
                omission: '…'
            }) === d.text).color);

            tableConfig = this.getTableConfig(tableDataSource);
            chartConfig = this.getChartConfig(chartDataSource);
        } else {
            tableConfig = this.getTableConfig(this.createDataSource());
            chartConfig = this.getChartConfig(this.createDataSource(7, 16));
        }

        (this: any)._table.setOptions(tableConfig);
        (this: any)._chart.setOptions(chartConfig);
        this.updateLegend();
    }

    createDropdownOptions () {
        return _.concat(_(this.featuresProperties[0])
            .map((val, key) => {
                return { text: translate(`Common.${key.toCapitalCase()}`), value: key };
            })
            .orderBy('text')
            .filter((d) => {
                return _.some([
                    'family',
                    'group',
                    'name',
                    'type'
                ], p => p === d.value);
            })
            .value());
    }

    aggregateBy (property) {
        return _.reduce(this.featuresProperties, (res, feature) => {
            if (_.some(['type'], p => p === property)) {
                if (feature[property]) {
                    res[translate(`Retention.Classification.${feature[property]}`)] = (res[translate(`Retention.Classification.${feature[property]}`)] || 0) + 1;
                }
            } else {
                if (feature[property]) {
                    res[feature[property]] = (res[feature[property]] || 0) + 1;
                }
            }
            return res;
        }, {});
    }
}

export default Retention;



// WEBPACK FOOTER //
// ./src/scripts/core/selection/Retention.js